import { render, staticRenderFns } from "./ProductsProvider.vue?vue&type=template&id=1d7feeac&"
import script from "./ProductsProvider.vue?vue&type=script&lang=js&"
export * from "./ProductsProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports